import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  connect() {
    this.token = document.querySelector('meta[name="csrf-token"]')?.content;
  }

  fileUploaded(event) {
    fetch(
      `/document_templates/new?blob_signed_id=${event.detail.blob_signed_id}`,
      {
        method: "GET",
        headers: {
          "X-CSRF-Token": this.token,
          Accept: "text/vnd.turbo-stream.html",
        },
      }
    )
      .then((response) => response.ok && response.text())
      .then((html) => {
        Turbo.renderStreamMessage(html);
      });
  }
}
